import {Route} from "react-router-dom";
import PrivateRoute from "context/PrivateRoute";
// import Reports from "./ReportAlerts";
import ReportExecutive from "./ReportExecutive";
import ReportPerformance from "./ReportPerformance";
import ReportCollectionsAnalysis from "./ReportCollectionsAnalysis";
import ReportContainerPickedUp from "./ReportContainersList";
import ReportContainerPickedUpGraph from "./ReportContainerGraph";
import MainReports from "./MainReports";
import ReportRoutes from "./ReportRoutes";
import ReportProgramming from "./ReportProgramming";

// prettier-ignore

const RoutesReports = () => {

       return (
              <>
                     <Route path="reports"
                            element={<PrivateRoute role="tech" panelType="w"><MainReports /></PrivateRoute>} />

                     <Route path="reports/performance"
                            element={<PrivateRoute role="tech" panelType="w"><ReportPerformance /></PrivateRoute>} />

                     <Route path="reports/collections-analysis"
                            element={<PrivateRoute role="tech" panelType="w"><ReportCollectionsAnalysis /></PrivateRoute>} />

                     <Route path="reports/containers-picked-up"
                            element={<PrivateRoute role="tech" panelType="w"><ReportContainerPickedUp /></PrivateRoute>} />

                     <Route path="reports/containers-picked-up/graph"
                            element={<PrivateRoute role="tech" panelType="w"><ReportContainerPickedUpGraph /></PrivateRoute>} />

                     <Route path="reports/alerts"
                            element={<PrivateRoute role="tech" panelType="w"><MainReports /></PrivateRoute>} />

                     <Route path="reports/routes"
                            element={<PrivateRoute role="tech" panelType="w"><ReportRoutes /></PrivateRoute>} />

                     <Route path="reports/programing"
                            element={<PrivateRoute role="admin" panelType="w"><ReportProgramming/></PrivateRoute>}/>             
              </>
       )
}
export default RoutesReports;
